import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=89e4255c&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=89e4255c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e4255c",
  null
  
)

export default component.exports